module.exports = __webpack_public_path__ + "img/icon_up_result_pop__001.194478d7.png";